import script from "./PageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSelector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__